<template>
  <b-container fluid>
    <h1 class="mb-4 display-title">Solicitudes de Alta Medica {{getEstablecimiento.DisplayNivelAsignado}}</h1>
    <hr />
    <filtro-solicitud-alta-medica></filtro-solicitud-alta-medica>
    <b-row class="mt-4">
      <b-col md="12">
        <div v-if="listaSolicitudes.rows.length > 0">
          <lista-solicitud-alta-medica></lista-solicitud-alta-medica>
        </div>

        <b-alert show variant="warning" v-if="listaSolicitudes.rows.length == 0">
          No se encontraron resultados
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import axios from "axios";
import moment from "moment";
import qs from "qs";
import multiselect from "vue-multiselect";
//import SolicitudAltasvc from "@/services/solicitudalta";
import FiltroSolicitudAltaMedica from "../../common/FiltroSolicitudAltaMedica.vue";
import ListaSolicitudAltaMedica from "../../common/ListaSolicitudAltaMedica.vue";
import Jumbotron from "../../common/Jumbotron.vue";
//import api from "@/api";
import { mapGetters, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'SolicitudAltaModule/getSolicitudAltaField'
});

export default {
  mixins: [errorhandler, swalerts],
  computed: {
    ...mapGetters(["getEstablecimiento"]),
    ...mapFields({
      filtroEstado: 'filtro.estado',
      filtroDestino: 'filtro.destino',
      listaSolicitudes: 'tabla',
      errorLista: 'tabla.error',
      isError: 'tabla.error.activo',
      formData: 'formdata'
    }),
  },
  watch: {
    isError: function(newvalue, oldvalue) {
      console.log("isError newvalue oldvalue", newvalue, oldvalue);
      if(this.errorLista.activo){
        this.showError(this.errorLista.mensaje ? this.errorLista.mensaje : "ERROR");
        this.setTablaError( { activo:false, mensaje:''});
      }
    },
    getEstablecimiento: function(newvalue, oldvalue) {
      console.log("refresh table newvalue oldvalue", newvalue, oldvalue);
      this.solicitudProviderLocal(1);
    }
  },
  components: {
    multiselect,
    FiltroSolicitudAltaMedica,
    ListaSolicitudAltaMedica,
    Jumbotron
  },
  data() {
    return {
      disabled: false
    };
  },

  methods: {
    ...mapActions("SolicitudAltaModule",
      ["solicitudProvider", "setTablaError", "getFormData", "setFiltroEstado", "setFiltroFechaPresentacion"]),
    solicitudProviderLocal: function(resetPagination) {
      console.log('resetPagination', resetPagination);
      return this.solicitudProvider(resetPagination);
    },
  },
  mounted() {
    var parameters = this.$route.query
    console.log('parameters', parameters)
    console.log('mounted', process.env);
    if (window.sessionStorage.getItem("filtro") === null) {

      var mesAnterior = moment().subtract(6, 'months').format("YYYY-MM-DD");
      var hoy = moment().format("YYYY-MM-DD");
      this.setFiltroFechaPresentacion({ desde: mesAnterior, hasta: hoy });

      this.disabled = true;
      this.getFormData(0).then(r => {
        this.setFiltroEstado(parameters.estado);
        this.solicitudProviderLocal(1).then(s => {
          console.log('solicitudProviderLocal then',s);
          this.disabled = false;
        });
      });
    }else{
      this.setFiltroEstado(parameters.estado);
      this.solicitudProviderLocal(1).then(s => {
        console.log('solicitudProviderLocal then',s);
        this.disabled = false;
      });
    }
  }
};
</script>

<style>
.form-control:focus , .custom-select:focus {
  border-color: #41b883;

  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset,
    0px 0px 8px rgba(65, 184, 131, 0.5)
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solicitudes/ConsultaSolicitudAltaMedica.vue